import React from 'react';
import { CaptionText } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import { localsMessages } from '../utility/getTemplateData';

const messages = localsMessages('buttons/partner') || {};

const styles = StyleSheet.create({
  disclaimerWrapper: {
    maxWidth: 350,
    margin: 'auto',
    '.ppvx_accordion__row': { border: 'none' },
  },
  disclaimer: {
    margin: 'auto',
  },
  disclaimerCaptionText: {
    marginTop: 12,
    color: '#687173',
    textAlign: 'center',
  },
});

export default function NotTaxDeductibleLegalText() {
  return (
    <div className={` ${css(styles.disclaimerWrapper)}`}>
      <CaptionText className={` ${css(styles.disclaimerCaptionText)}`}>
        {messages.landing.mayNotBeTaxDeductible}
      </CaptionText>
    </div>
  );
}
